import { GOL, ARGOS, TU, BANK, AFS, HABITAT } from "constants/missions";
import { TERMS_AND_CONDITIONS, CONSENT_ALL } from "constants/registrationForm";
import { missionId } from "utils/urls";

export const buildInitialValues = (formValues) => {
  const { preferences } = formValues || {};
  return Object.assign(
    {},
    ...Object.keys(formValues).map((key) => {
      return Object.keys(formValues[key]["elements"]).reduce(
        (total, elemKey) => {
          const value = formValues[key]["elements"][elemKey];
          const elemValue = elemKey === TERMS_AND_CONDITIONS ? false : "";
          return value ? ((total[elemKey] = elemValue), total) : total;
        },
        {}
      );
    }),
    {
      ...(preferences
        ? {
            preferences: {
              [GOL]: false,
              [ARGOS]: false,
              [TU]: false,
              [BANK]: false,
              [AFS]: false,
              [HABITAT]: false,
            },
          }
        : {}),
    },
    { [CONSENT_ALL]: "N" }
  );
};

export const buildFormData = (values, regFormData) => {
  let { preferences: prefs } = regFormData;

  prefs = prefs
    ? {
        preferences: {
          mission_code: missionId,
          touchpoint: "New Account Registration",
          ...(values.consent_all === "Y" ? { consent: "Y" } : null),
          ...(values.consent_all === "N"
            ? {
                consents: Object.keys(values.preferences).map((key) => ({
                  mission_name: key,
                  consent: values.preferences[key] ? "Y" : "N",
                })),
              }
            : null),
        },
      }
    : null;

  const {
    preferences,
    consent_all,
    title,
    mobile_number,
    ...newValues
  } = values;

  const titleProp = values.title ? { title: values.title } : { title: "mx" };

  const mobileNumber = values.mobile_number
    ? {
        mobile_number: {
          country_code: values.mobile_number.country_code,
          subscriber_number: values.mobile_number.subscriber_number,
        },
      }
    : null;

  return {
    ...newValues,
    ...prefs,
    ...titleProp,
    ...mobileNumber,
  };
};
